import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BundleSection } from '../components/BundleSection';
import { PriceJustification } from '../components/PriceJustification';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { CTAButton } from '../components/CTAButton';
export function VitalityLandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-neutral-950 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-248">
      <main data-id="element-249">
        <HeroSection data-id="element-250" />
        <ProblemSection data-id="element-251" />
        <SolutionSection data-id="element-252" />
        <BundleSection data-id="element-253" />
        <PriceJustification data-id="element-254" />
        <GuaranteeSection data-id="element-255" />
        <TestimonialSection data-id="element-256" />
        <FAQSection data-id="element-257" />

        {/* Final CTA Section */}
        <section className="bg-neutral-950 text-white py-24 px-4 text-center relative overflow-hidden" data-id="element-258">
          <div className="absolute inset-0 bg-gradient-to-t from-amber-500/10 to-transparent pointer-events-none" data-id="element-259"></div>
          <div className="max-w-3xl mx-auto relative z-10" data-id="element-260">
            <h2 className="text-4xl md:text-6xl font-extrabold mb-8" data-id="element-261">
              Your Edge is Waiting.
            </h2>
            <p className="text-xl text-gray-400 mb-10" data-id="element-262">
              Join thousands of high-performing men who have already reclaimed
              their energy, focus, and drive.
            </p>
            <CTAButton text="I'M READY TO RECLAIM MY EDGE" className="w-full md:w-auto min-w-[320px] text-xl py-6" data-id="element-263" />
            <p className="mt-6 text-gray-500 text-sm" data-id="element-264">
              Secure 256-bit Encryption. 30-Day Money-Back Guarantee.
            </p>

            {/* Price Anchor Block */}
          </div>
        </section>
      </main>

      <Footer data-id="element-265" />
    </div>;
}